import React, { useState, useEffect } from "react";
import styles from "./PasswordResetRequest.module.css";

import BackToLoginPageButton from "../../Components/BackToLoginPageButton/BackToLoginPageButton";

import { requestForgotPasswordReset } from "../../Api/Backend/Auth";


// .../login/password-reset-request
function PasswordResetRequest({ }) {
    const [email, setEmail] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [cooldown, setCooldown] = useState(0);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSendEmail = async (e) => {
        e.preventDefault();

        if (!email || isSending) return;

        setErrorMessage(null);
        setIsSending(true);
        setCooldown(30);

        await requestForgotPasswordReset({
            email: email,
            onSuccess: () => {
                setEmailSent(true);
            },
            onError: (error) => {
                console.error("Error sending email: ", error);
                setErrorMessage(error.message || "이메일 전송 중 오류가 발생했습니다.");
                setEmailSent(false);
            }
        });

        setIsSending(false);
    };

    useEffect(() => {
        if (cooldown <= 0) return;

        const timer = setInterval(() => {
            setCooldown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [cooldown]);

    return (
        <div className={styles.passwordResetRequest}>
            <img className={styles.acornIcon} src="/images/logo.svg" alt="에이콘 로고" />
            <div className={styles.title}>
                {emailSent ? "이메일이 발송되었습니다. 확인해주세요" : "비밀번호 재설정"}
            </div>
            <div className={styles.description}>
                {emailSent ? "이메일을 열어 비밀번호 재설정을 완료해 주세요." : "계정에 등록된 이메일 주소를 입력해 주세요."}
            </div>

            {emailSent ? (
                <div className={styles.resendEmailContainer}>
                    <button
                        className={styles.sendEmailButton}
                        onClick={handleSendEmail}
                        disabled={isSending || cooldown > 0}
                    >
                        {cooldown > 0 ? `${cooldown}초 후 재전송 가능` : "이메일 다시 발송"}
                    </button>
                </div>
            ) : (
                <form onSubmit={handleSendEmail}>
                    <input
                        className={styles.inputBox}
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="아이디 이메일"
                        disabled={isSending}
                        required
                    />
                    <button
                        className={styles.sendEmailButton}
                        type="submit"
                        disabled={isSending || !email}
                    >
                        {cooldown > 0 ? `${cooldown}초 후 재전송 가능` : "이메일 보내기"}
                    </button>
                </form>
            )}

            {errorMessage &&
                <div className={styles.errorMessage}>{errorMessage}</div>
            }

            <BackToLoginPageButton />
        </div>
    );
}

export default PasswordResetRequest;